import { render, staticRenderFns } from "./IndexColumnSetparam.vue?vue&type=template&id=95789b78&"
import script from "./IndexColumnSetparam.vue?vue&type=script&lang=js&"
export * from "./IndexColumnSetparam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports